import { jsx } from 'react/jsx-runtime';
import * as AlertDialogPrimitive from '@radix-ui/react-alert-dialog';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { contentPositionerStyle } from '../../dialog.vanilla.mjs';

const ContentPositioner = forwardRef(({ className, ...props }, ref) => {
  return /* @__PURE__ */ jsx(
    AlertDialogPrimitive.Overlay,
    {
      ref,
      className: classNames(className, contentPositionerStyle),
      ...props
    }
  );
});

export { ContentPositioner };
//# sourceMappingURL=ContentPositioner.mjs.map
